'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _createColor = require('./createColor'),
    _createColor2 = _interopRequireDefault(_createColor),
    _createTypography = require('./createTypography'),
    _createTypography2 = _interopRequireDefault(_createTypography),
    _createTransitions = require('./createTransitions'),
    _createTransitions2 = _interopRequireDefault(_createTransitions),
    _createShape = require('./createShape'),
    _createShape2 = _interopRequireDefault(_createShape),
    _createSizes = require('./createSizes'),
    _createSizes2 = _interopRequireDefault(_createSizes),
    _createZIndex = require('./createZIndex'),
    _createZIndex2 = _interopRequireDefault(_createZIndex),
    _createBoxShadows = require('./createBoxShadows'),
    _createBoxShadows2 = _interopRequireDefault(_createBoxShadows);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var createTheme = function createTheme() {
  var options = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      _options$color = options.color,
      colorInput = _options$color === void 0 ? {} : _options$color,
      _options$direction = options.direction,
      direction = _options$direction === void 0 ? 'ltr' : _options$direction,
      _options$shadow = options.shadow,
      shadowInput = _options$shadow === void 0 ? {} : _options$shadow,
      _options$shape = options.shape,
      shapeInput = _options$shape === void 0 ? {} : _options$shape,
      _options$size = options.size,
      sizeInput = _options$size === void 0 ? {} : _options$size,
      _options$transition = options.transition,
      transitionInput = _options$transition === void 0 ? {} : _options$transition,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      _options$zIndex = options.zIndex,
      zIndexInput = _options$zIndex === void 0 ? {} : _options$zIndex,
      color = (0, _createColor2.default)(colorInput),
      shadow = (0, _createBoxShadows2.default)(shadowInput),
      shape = (0, _createShape2.default)(shapeInput),
      size = (0, _createSizes2.default)(sizeInput),
      transition = (0, _createTransitions2.default)(transitionInput),
      typography = (0, _createTypography2.default)(typographyInput),
      zIndex = (0, _createZIndex2.default)(zIndexInput);
  return {
    vstui: {
      breakpoint: {
        xs: '(max-width: 375px)'
      },
      color: color,
      direction: direction,
      rem: function rem(value) {
        var remRegex = /rem$/,
            pxRegex = /px$/;
        if ('inherit' === value) return value;
        if ('number' == typeof value) return typography.pxToRem(value);

        if ('string' == typeof value) {
          if (value.match(remRegex)) return value;

          if (value.match(pxRegex)) {
            var unitlessValue = value.split(pxRegex)[0],
                number = parseInt(unitlessValue, 10);
            return typography.pxToRem(number);
          }
        }

        throw new Error('rem: invalid value');
      },
      shadow: shadow,
      shape: shape,
      size: size,
      typography: typography,
      transition: transition,
      zIndex: zIndex
    }
  };
};

exports.default = createTheme;